<template>
  <div class="form-container">
    <teleport to="body">
      <div class="page-overlay" v-if="isLoading">
        <base-loader />
      </div>
    </teleport>

    <h3 class="form-title">Войти</h3>
    <base-error
      class="error_msg"
      :base-error="baseError"
      v-show="baseError.visible"
    />
    <!-- Форма логина -->
    <form class="form-login" @submit.prevent>
      <fieldset :disabled="isLoading" class="form-fieldset">
        <div class="form-group">
          <base-input
            placeholder="Email или телефон"
            v-model="loginFormData.login"
            required
          />
        </div>

        <div class="form-group">
          <base-input
            is-password
            placeholder="Пароль"
            v-model="loginFormData.password"
            required
            autocomplete="current-password"
          />
        </div>

        <div class="form-group options-row">
          <base-checkbox v-model="isForeignComputer">
            <base-tooltip
              text="Включите, если входите не со своего устройства"
              position="bottom"
            >
              <span class="session-option-label">Чужой компьютер</span>
            </base-tooltip>
          </base-checkbox>
        </div>

        <base-error-container
          class="error-box"
          :error-container-msg="errorContainerMsg"
          v-show="errorContainerMsg.visible"
        />

        <base-primary-button
          class="form-btn"
          type="submit"
          @click="postLoginData"
        >
          Войти
        </base-primary-button>
      </fieldset>
    </form>

    <button
      class="forgot-btn"
      :disabled="isLoading"
      @click="goToRecovery"
    >
      Забыли пароль?
    </button>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/authStore";

export default {
  name: "LoginForm",

  props: {
    baseErrorText: {
      type: String,
      required: false,
    },
    onSuccessfulLogin: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      loginFormData: {
        login: "",
        password: "",
        remember: true,
      },

      baseError: { visible: false, text: "Возникла ошибка" },
      errorContainerMsg: { visible: false, text: "" },
    };
  },

  computed: {
    authStore() {
      return useAuthStore();
    },

    isLoading() {
      return this.authStore.isSubmitting;
    },

    isForeignComputer: {
      get() {
        return !this.loginFormData.remember;
      },

      set(value) {
        this.loginFormData.remember = !value;
      },
    },
  },

  methods: {
    async postLoginData() {
      this.errorContainerMsg.visible = false;

      try {
        await this.authStore.loginWithCredentials(this.loginFormData);

        if (typeof this.onSuccessfulLogin === "function") {
          await this.onSuccessfulLogin();
        } else {
          const returnUrl = this.authStore.returnUrl;
          if (returnUrl) {
            await this.$router.push(returnUrl);
          } else {
            await this.$router.push({ name: "Home" });
          }
        }
      } catch (e) {
        this.errorContainerMsg.visible = true;
        if (e.response) {
          if (e.response.status === 401) {
            this.errorContainerMsg.text =
              "Пользователь с такими данными не найден";
          } else {
            this.errorContainerMsg.text =
              e.response.data?.errors || "Произошла ошибка";
          }
        } else {
          this.errorContainerMsg.text = "Ошибка сети или сервера";
        }
      }
    },

    goToRecovery() {
      this.$router.push({ name: "AccountRecovery" });
    },
  },

  created() {
    this.baseError.text = this.baseErrorText;
    if (this.baseErrorText !== "Возникла ошибка") {
      this.baseError.visible = true;
    }
  },
};
</script>

<style scoped>
.page-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.form-container {
  margin-top: 15vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 50px;
  background: var(--color-dark);
  border-radius: 20px;
}

.form-title {
  margin-bottom: var(--base-out-indent);
  font-size: 26px;
  font-weight: bold;
  color: var(--color-light);
}

.error_msg {
  width: 290px;
}

.form-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 290px;
}

.form-fieldset {
  display: contents;
  border: none;
  padding: 0;
  margin: 0;
}

.form-group {
  position: relative;
  width: 290px;
}

.options-row {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  color: var(--color-light);
}

.session-option-label {
  cursor: help;
}

.error-box {
  margin-bottom: var(--base-in-indent);
}

.form-btn {
  width: 290px;
}

.forgot-btn {
  width: max-content;
  height: max-content;
  margin-top: 20px;
  padding: 0;
  background-color: transparent;
  color: var(--color-light);
  font-size: 14px;
  text-decoration: underline;
  border: none;
  cursor: pointer;
}

.forgot-btn:hover {
  text-decoration: none;
  background-color: transparent;
}

.forgot-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  text-decoration: none;
}

@media screen and (max-width: 767px) {
  .form-container {
    padding-left: 0;
    padding-right: 0;
    border-radius: 0;
    background-color: transparent;
  }

  .form-title {
    margin-bottom: 20px;
  }
}
</style>
